































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IPaymentLog } from "@/models/paymentLog";
import { DataModules } from "@/store/modules/data";
import { TransactionStatusMapped } from "@/data/transactions";
import _ from "@/boot/lodash";

@Component({
  components: {}
})
export default class TransactionRowItem extends Vue {
  // Props

  @Prop({ default: null })
  public transaction!: IPaymentLog;

  @Prop({ required: true })
  public isLoading!: boolean;

  @Prop({ default: true })
  public showClient!: boolean;

  @Prop({ default: true })
  public showInvoice!: boolean;

  // Computed

  public get mappedStatus() {
    return TransactionStatusMapped(this.transaction.status);
  }

  public get gatewayName() {
    const { gateway } = this.transaction;
    if (!gateway) return this.$t("_.account_credit");
    return gateway?.name_translated || gateway?.name;
  }

  public get paymentDetail() {
    const { client_payment_details } = this.transaction;
    if (!client_payment_details) return "";
    return _.compact([
      _.upperFirst(client_payment_details?.card_type),
      "••••",
      client_payment_details?.card_last4
    ]).join(" ");
  }

  public openLogModal() {
    if (!this.transaction) return;
    return this.$store.dispatch(`data/${DataModules.LOGS}/openLogModal`, {
      props: {
        log: this.transaction,
        title: this.$t("_.transaction_num", {
          number: this.transaction.transaction_id as string
        }),
        deep: 1
      }
    });
  }
}
